import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { XaltTimeField } from 'xalt-react-atoms';
import RWFieldAction from './RWFieldAction';

/**
 * A platform component for building a client action
 */
class RWFieldActionTimePicker extends PureComponent {
    static propTypes = {
        style: PropTypes.object,
        action: PropTypes.object,
        onFieldAction: PropTypes.func,
        value: PropTypes.instanceOf(Date),
        is24Hour: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.handleOnActionClick = this.handleOnActionClick.bind(this);
        this.timePickerRef = React.createRef();
    }

    render() {
        const {
            is24Hour,
            value,
            ...restProps } = this.props;

        const standardActionPrps = {
            ...restProps,
            onFieldAction: this.handleOnActionClick, // override standard action click
        };

        return (
            <>
                <RWFieldAction { ...standardActionPrps } />
                <XaltTimeField
                    style={ { visibility: 'hidden', width: '0px' } }
                    inputRef={ this.timePickerRef }
                    is24Hour={ is24Hour }
                    onValueChanged={ this.handleOnChange }
                    value={ value } />
            </>
        );
    }

    handleOnChange = (date) => {
        const { action } = this.props;
        const { clientFunction } = action;
        if (clientFunction) {
            clientFunction(date);
        }
    };

    handleOnActionClick(event) {
        if (this.timePickerRef && this.timePickerRef.current) {
            this.timePickerRef.current.click(event);
        }
    }
}

export default RWFieldActionTimePicker;
